// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1CMGk","footer":"ChangeClinic_footer__25u8I"};